import { useEffect, useState } from 'react';
import { Competition, CompetitionAPI, API } from '@brg/api';
import { useTranslation } from 'react-i18next';

const ZHAR_KNIGA_COMPETITION_ID = '19624f65f36f414abed3891529626052';

// Кэш для хранения загруженного конкурса
let cachedCompetition: Competition | null = null;
let isLoading = false;
let loadPromise: Promise<Competition | null> | null = null;

export const useZharKnigaWinner = (projectId?: string) => {
  const [isWinner, setIsWinner] = useState(false);
  const [position, setPosition] = useState<number | undefined>(undefined);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!projectId) return;

    const checkWinner = async () => {
      // Если уже загружен - используем кэш
      if (cachedCompetition) {
        checkIfWinner(cachedCompetition, projectId);
        return;
      }

      // Если уже идет загрузка - ждем её
      if (isLoading && loadPromise) {
        const competition = await loadPromise;
        if (competition) {
          checkIfWinner(competition, projectId);
        }
        return;
      }

      // Загружаем конкурс
      isLoading = true;
      loadPromise = CompetitionAPI.Get({ idCompetition: ZHAR_KNIGA_COMPETITION_ID })
        .then((r) => r.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((competition) => {
          cachedCompetition = competition;
          isLoading = false;
          return competition;
        })
        .catch(() => {
          isLoading = false;
          return null;
        });

      const competition = await loadPromise;
      if (competition) {
        checkIfWinner(competition, projectId);
      }
    };

    const checkIfWinner = (competition: Competition, projectId: string) => {
      // @ts-ignore
      const winnerPositions = competition?.nominations?.[0]?.winnerPositions || [];
      const winner = winnerPositions.find((w: any) => w.winnerId === projectId);
      
      if (winner) {
        setIsWinner(true);
        setPosition(winner.position);
      } else {
        setIsWinner(false);
        setPosition(undefined);
      }
    };

    checkWinner();
  }, [projectId, i18n.language]);

  return { isWinner, position };
};

import { useEffect, useState } from 'react';
import { Competition, CompetitionAPI, API } from '@brg/api';
import { useTranslation } from 'react-i18next';

const ZHAR_KNIGA_COMPETITION_ID = '19624f65f36f414abed3891529626052';

// Кэш для хранения загруженного конкурса
let cachedCompetition: Competition | null = null;
let isLoading = false;
let loadPromise: Promise<Competition | null> | null = null;

export const useZharKnigaWinner = (projectId?: string) => {
  const [isWinner, setIsWinner] = useState(false);
  const [position, setPosition] = useState<number | undefined>(undefined);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!projectId) return;

    const checkWinner = async () => {
      // Если уже загружен - используем кэш
      if (cachedCompetition) {
        checkIfWinner(cachedCompetition, projectId);
        return;
      }

      // Если уже идет загрузка - ждем её
      if (isLoading && loadPromise) {
        const competition = await loadPromise;
        if (competition) {
          checkIfWinner(competition, projectId);
        }
        return;
      }

      // Загружаем конкурс
      isLoading = true;
      loadPromise = CompetitionAPI.Get({ idCompetition: ZHAR_KNIGA_COMPETITION_ID })
        .then((r) => r.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((competition) => {
          cachedCompetition = competition;
          isLoading = false;
          return competition;
        })
        .catch(() => {
          isLoading = false;
          return null;
        });

      const competition = await loadPromise;
      if (competition) {
        checkIfWinner(competition, projectId);
      }
    };

    const checkIfWinner = (competition: Competition, projectId: string) => {
      // @ts-ignore
      const winnerPositions = competition?.nominations?.[0]?.winnerPositions || [];
      const winner = winnerPositions.find((w: any) => w.winnerId === projectId);
      
      if (winner) {
        setIsWinner(true);
        setPosition(winner.position);
      } else {
        setIsWinner(false);
        setPosition(undefined);
      }
    };

    checkWinner();
  }, [projectId, i18n.language]);

  return { isWinner, position };
};

